import { useCallback, useEffect, useState } from 'react';
import type { SellerConnection } from '../../api/amazonconnect';
import { fetchCommerceHealth } from '../commerceHealth';
import type { CompareMode, DatePreset } from '../types';
import { loadExecutiveKpis } from './loadExecutiveKpis';
import type { ExecutiveKpiStripModel } from './types';

export function useExecutiveKpis(opts: {
  refreshToken?: number;
  connectionId: string;
  connection: SellerConnection | null;
  datePreset: DatePreset;
  compare: CompareMode;
}) {
  const { refreshToken = 0, connectionId, connection, datePreset, compare } = opts;
  const [model, setModel] = useState<ExecutiveKpiStripModel | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    setLoading(true);
    setError(null);
    let health = connectionId ? await fetchCommerceHealth(connectionId) : null;
    try {
      const m = await loadExecutiveKpis({
        connection,
        health,
        datePreset,
        compare,
      });
      setModel(m);
      if (m.error) setError(m.error);
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Failed to load Executive KPIs');
      setModel(null);
    } finally {
      setLoading(false);
    }
  }, [connection, connectionId, datePreset, compare]);

  useEffect(() => {
    void reload();
  }, [reload, refreshToken]);

  return { model, loading, error, reload };
}
